import _ from 'lodash';

import authValidators from 'auth/validators/action-validators';
import contactValidators from 'contact/validators/action-validators';
import documentsValidators from 'documents/validators/action-validators';
import emailNotificationTemplatesValidators from 'email-notification-templates/validators/action-validators';
import smsValidators from 'sms/validators/action-validators';
import faqValidators from 'faq/validators/action-validators';
import privilegeTemplatesValidators from 'privilege-templates/validators/action-validators';
import registrationValidators from 'registration/validators/action-validators';
import reportSubscriptionsValidators from 'report-subscriptions/validators/action-validators';
import retailerReportsValidators from 'retailer-reports/validators/action-validators';
import securityValidators from 'security/validators/action-validators';
import storeProfilesValidators from 'store-profiles/validators/action-validators';
import manageInventoryValidators from 'manage-inventory/validators/action-validators';
import dashboardValidators from 'dashboard/validators/action-validators';
import userValidators from 'user/validators/action-validators';

const initialState = {
  validators: _.merge(
    authValidators,
    contactValidators,
    documentsValidators,
    emailNotificationTemplatesValidators,
    smsValidators,
    faqValidators,
    privilegeTemplatesValidators,
    registrationValidators,
    reportSubscriptionsValidators,
    retailerReportsValidators,
    securityValidators,
    storeProfilesValidators,
    manageInventoryValidators,
    dashboardValidators,
    userValidators,
    userValidators,
  ),
};

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/app.reducer.js